var swiperHelper;

function swiperHelper(){
    let me = this;
    me.logo;
    me.swipers = {};
    me.adv = 0;

    me.init = (offset) => {
        me.logo = document.getElementById("dm20-header-logo-img");
        me.breakpoint1000 = window.matchMedia('(min-width:1000px)');
        me.breakpoint1200 = window.matchMedia('(min-width:1200px)');

        me.offset = 0;
        if(offset){
            me.offset = offset;
        }

        me.setupSwipers();
        me.initSwipers();

        window.addEventListener('MMSkinGo', () => {
            me.updateSwipers();
        }, false);

        me.breakpoint1000.addListener(me.breakpointChecker);
        me.breakpoint1200.addListener(me.breakpointChecker);
	};

    me.breakpointChecker = () => {
        setTimeout(() => {me.updateSwipers();}, 300);
    };

    me.setupSwipers = () => {
        let swiperContainers = document.querySelectorAll(".dm20-swiper-container");

        for(let i=0; i<swiperContainers.length; i++){
            let target = swiperContainers[i],
                name = target.dataset.swipername,
                type = target.dataset.swipertype,
                load = target.dataset.swiperload
                callback = target.dataset.swipercallback || false;

            me.swipers[name] = {
                "target": target,
                "type": type,
                "load": load,
				"callback": callback
            };
        }

        me.setSlides();
    };

    me.setSlides = () => {
        for(let name in me.swipers){
            let type = me.swipers[name].type;
            let load = me.swipers[name].load;

            switch(type){
                case "main":
                    me.setMainSlides(name);
                break;

                case "default":
                    me.setDefaultSlides(name);
                break;
            }
        }
    };

    me.setDefaultSlides = (name) => {
        me.swipers[name]["slides"] = me.getSlidesFromDOM(name);
    };

    me.getSlidesFromDOM = (name) => {
        var slides = [];
        let target = me.swipers[name].target;
        let slidesDOM = [].slice.call(target.querySelectorAll(":scope > .dm20-swiper-slide"));
        for(var i=0; i<slidesDOM.length; i++){
            var slide = slidesDOM[i];
            slides.push(slide.outerHTML);
        }

        return slides;
    };

    me.initSwipers = () => {
        for(var name in me.swipers){
            if(me.swipers[name].load == "default"){
                var target = me.swipers[name].target;
                me.swipers[name]["swiper"] = me.initSwiper(target);
            }
        }

        me.processLazySwipers();
        window.addEventListener('scroll', function() {
			me.processLazySwipers();
		});
    };

    me.processLazySwipers = () => {
        for(var name in me.swipers){
            if(me.swipers[name].load == "lazy"){
                var target = me.swipers[name].target;
                if(me.toProcessLazySwipers(target) && !target.classList.contains('processed')){
                    me.swipers[name]["swiper"] = me.initSwiper(target);
                    target.classList.add('processed');
                }
            }
        }
    };

    me.toProcessLazySwipers = (element) => {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
		return (
			(rect.top - me.offset) <= (window.innerHeight || html.clientHeight) && (rect.top + rect.height) >= 0
		);
    };

    me.setMainSlides = (name) =>{
        let swiper = me.swipers[name];

		if(swiper.swiper === undefined){
            swiper["swiper"] = me.initMainSwiper(swiper.target);
            swiper.target.classList.add("dm20-swiper-dom-loaded");
        }
    };

    me.initSwiper = (target, loop) => {
        var loadedslide = false;
        var swiper = new Swiper(target, {
            breakpointsInverse: true,
            navigation: {
                nextEl: target.parentNode.querySelectorAll(':scope > .dm20-arrow-button-next'),
                prevEl: target.parentNode.querySelectorAll(':scope > .dm20-arrow-button-prev')
            },
            pagination: {
                el: target.parentNode.querySelector('.dm20-swiper-pagination-fraction'),
                type: 'fraction',
            },
            loop: target.dataset.swiperloop ? target.dataset.swiperloop : false,
            loopedSlides: 3,
            slidesPerView: "auto",
			slidesPerGroup: 1,
            calculateHeight:true,
            autoHeight:true,
            simulateTouch: false,
            observeParents: true,
            on: {
                init: function (swiper) {
                    if (device != 'desktop') {
                        // se non siamo in apertura
                        if (!this.el.parentNode.classList.contains('dm20-lory-media')) {
                            // ciclo for al contrario per aggiungere le slide dalla fine (altrimenti la numerazione tiene conto delle slide nuove)
                            for (let total = this.slides.length - this.loopedSlides*2; total > 0; total--) {
                                // console.log(total);
                                if (total != 0 && total % 2 === 0) {
                                    this.addSlide(total, '<div class="swiper-slide dm20-swiper-slide dm20-swiper-adv dm20-chiara-slide"><div class="dm20-chiara-figure dm20-figure-filter"></div></div>');
                                }
                            }
                            // ciclo dritto per evitare i duplicati del loop
                            let advslides = this.el.querySelectorAll('.dm20-swiper-slide.dm20-swiper-adv .dm20-chiara-figure');

                            advslides.forEach(advslide => {
                                // console.log(advslide.classList);
                                advslide.innerHTML = '<div class="amePlaceholderBox"><div data-adv="' + me.adv + '" id="adv-gpt-box-mobile-gallery-container' + me.adv + '"></div></div>';
                                me.adv++;
                            });
                            // carico il primo slot subito
                            let nextadv = this.el.querySelector('.swiper-slide-next').nextElementSibling;
                            me.loadslot(nextadv);
                        }
                    }
                },
                slideChangeTransitionEnd: function (swiper) {
                    if (loadedslide) {
                        var realindex = parseInt(target.querySelector('.swiper-slide-active').dataset.swiperSlideIndex);

                        let eventSlideChangeTransitionEnd = new CustomEvent("SwiperChange",{detail: {slide: "image_" + realindex}});
                        document.dispatchEvent(eventSlideChangeTransitionEnd);
                    }
                    loadedslide = true;
                    // ad ogni cambio slide vedo se ci sono slot vuoti nelle prossime due slide
                    let nextadv = this.el.querySelector('.swiper-slide-next');
                    let nextadv2 = this.el.querySelector('.swiper-slide-next').nextElementSibling;
                  
                    me.loadslot(nextadv);
                    me.loadslot(nextadv2);
                }
            }
        });

        return swiper;
    };

    me.loadslot = (target) => {
        if (target.classList.contains('dm20-swiper-adv')) {
            console.log(target);
            let adv = target.querySelector('.amePlaceholderBox [id^=adv-gpt-box-mobile-gallery-container]:empty');
            if (adv) { // prendo solo i blocchi vuoti
                // console.log(adv);
                if (typeof generaGptGallery === "function") { 
                    generaGptGallery(parseInt(adv.dataset.adv, 10));
                    console.log('siamo dentro adv gallery - carico lo slot ' + adv.dataset.adv);
                }
                // adv.innerHTML = 'CARICATO LO SLOT ' + adv.dataset.adv;
            }
        }
    }

    me.initMainSwiper = (target) => {
        var isHome = target.dataset.ishome ? target.dataset.ishome : false;
        let swiper = new Swiper(target, {
            breakpointsInverse: true,
			speed: 300,
            slideActiveClass: 'dm20-swiper-slide-active',
			autoplay: {
				delay: 6000,
				disableOnInteraction: false
			},
			navigation: {
                nextEl: target.parentNode.querySelectorAll(':scope > .dm20-arrow-button-next'),
                prevEl: target.parentNode.querySelectorAll(':scope > .dm20-arrow-button-prev')
            },
            loop: true,
			updateOnImagesReady: true,
            slidesPerView: "auto",
            simulateTouch: false,
            breakpoints: {
                1000: {
					loop: true
                },
                1200: {
					loop: true
                }
            },
            on: {
                transitionStart: () => {
                    // if(isHome){
                    //     let activeSlide = target.querySelector('.dm20-swiper-slide-active');
                    //     let channel = activeSlide.dataset.channel;

                    //     me.logo.setAttribute("class","");
                    //     me.logo.classList.add("dm20-" + channel);
                    // }
                }
            }
        });

        return swiper;
    };

    me.getSwipers = function(){
		return me.swipers;
	};

    me.updateSwipers = () => {
        for(const i in me.swipers){
            me.swipers[i].swiper.update();
        }
    };
}
